'use strict';
module.exports = (promise, onFinally) => {
	onFinally = onFinally || (() => {});

	return promise.then(
		val => new Promise(resolve => {
			resolve(onFinally());
		}).then(() => val),
		err => new Promise(resolve => {
			resolve(onFinally());
		}).then(() => {
			throw err;
		})
	);
};



//////////////////
// WEBPACK FOOTER
// ./~/p-finally/index.js
// module id = 507
// module chunks = 0 1 2 3